import { BFFBadRequest } from '../../interfaces/BFFBadRequest';
import unflattenObject from './unflattenObject';

export default function mapControlErrors(r: BFFBadRequest, controlErrorMapping: { [name: string]: string }): unknown {
  if (!r?.data?.errors) {
    return {};
  }
  const obj = Object.fromEntries(r.data.errors
    .filter((x) => controlErrorMapping[x.field] !== undefined)
    .map((x) => {
      const rawFieldMappingPath = controlErrorMapping[x.field].split('|');
      let fieldMap: readonly [PropertyKey, unknown];
      for (let i = 1; i <= rawFieldMappingPath.length; i++) {
        const fieldPathPart = rawFieldMappingPath[rawFieldMappingPath.length - i];
        fieldMap = i === 1 ?
          [fieldPathPart, { validationMessage: x.message }] :
          [fieldPathPart, Object.fromEntries([fieldMap])];
      }
      return fieldMap;
    }));
  const flatObj = unflattenObject(obj);
  return flatObj;
}
